export const launchTrackStorageKey = 'wt_launch-param';
export const trackQueueStorageKey = 'wt_queue'; // 补偿队列 // todo: 失败时将请求加入缓存以便后续补偿
export const sessionIdStorageKey = 'wt_session-id';
